
import * as environment from './values'

export default environment
// export * from './values'
